import {
  HIDDEN_ERROR_CODES,
  INTERNAL_ERROR_CODE_TEXT,
} from '../constants/error-codes';

export const isDisplayableErrorCode = (errorCode) => (
  Boolean(errorCode)
  && !HIDDEN_ERROR_CODES.includes(Number(errorCode.code))
  && !errorCode.isInformational
);

export const getDisplayableErrorCodes = (externalStatus) => {
  const detailedErrorCodes = externalStatus?.detailedErrorCodes ?? [];
  if (detailedErrorCodes.length > 0) {
    return detailedErrorCodes.filter(isDisplayableErrorCode);
  }
  const errorCode = externalStatus?.errorCode ?? null;
  return isDisplayableErrorCode(errorCode) ? [errorCode] : [];
};

export const getErrorCodeText = (errorCode) => INTERNAL_ERROR_CODE_TEXT[Number(errorCode.code)]
  ?? `${errorCode.code} - ${errorCode.description}`;
